import { playUiClick } from '../../assets/preloadSounds';
import type { PauseScreenModel } from './PauseScreenModelScreen';

export class PauseScreenController {
  constructor(private readonly model: PauseScreenModel) {}

  handleContinue = () => {
    playUiClick();
    this.model.onContinue?.();
  };

  handleGoHome = () => {
    playUiClick();
    this.model.onGoHome?.();
  };

  handleCycleAudioLevel = () => {
    playUiClick();
    this.model.onCycleAudioLevel?.();
  };
}
